import type { OutreachSequence } from '@client-outreach/shared';

/** One UK calendar day regardless of the browser timezone. */
export function ukDayKey(iso:string|undefined):string{
  if(!iso)return '';
  const date=new Date(iso);if(!Number.isFinite(date.getTime()))return '';
  const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
  const get=(type:string)=>parts.find(p=>p.type===type)?.value||'';
  return `${get('year')}-${get('month')}-${get('day')}`;
}
export type DayEvent={sequence:OutreachSequence;sentAt:string;kind:'First touch'|'Follow-up'};
export function dailyOutreach(sequences:OutreachSequence[],day:string){
  const sent:DayEvent[]=[];
  const scheduled:{sequence:OutreachSequence;dueAt:string;kind:'First touch'|'Follow-up'}[]=[];
  for(const s of sequences){
    if(s.archived||s.removedFromSentAt)continue;
    if(s.firstSentAt&&ukDayKey(s.firstSentAt)===day)sent.push({sequence:s,sentAt:s.firstSentAt,kind:'First touch'});
    if(s.followUpSentAt&&ukDayKey(s.followUpSentAt)===day)sent.push({sequence:s,sentAt:s.followUpSentAt,kind:'Follow-up'});
    if(s.stage==='scheduled'&&s.scheduledAt&&ukDayKey(s.scheduledAt)===day)scheduled.push({sequence:s,dueAt:s.scheduledAt,kind:'First touch'});
    if(s.stage==='sent'&&s.followUpDueAt&&!s.followUpSentAt&&s.followUpMessageId&&s.followUpStatus!=='cancelled'&&ukDayKey(s.followUpDueAt)===day)scheduled.push({sequence:s,dueAt:s.followUpDueAt,kind:'Follow-up'});
  }
  sent.sort((a,b)=>b.sentAt.localeCompare(a.sentAt));
  scheduled.sort((a,b)=>a.dueAt.localeCompare(b.dueAt));
  return {sent,scheduled};
}
